// Deriva las incidencias (celdas en FALLA) del dataset de inspección.
// severidad: máxima de los hallazgos estructurados de la celda (default MEDIA
// cuando no hay hallazgos con severidad — p. ej. data legacy).
const SEV_ORDER = { BAJA: 1, MEDIA: 2, ALTA: 3, CRITICA: 4 };

function maxSeveridad(hallazgos) {
  const present = (hallazgos || [])
    .map((h) => String(h?.severidad || '').toUpperCase())
    .filter((s) => SEV_ORDER[s]);
  if (present.length === 0) return 'MEDIA';
  return present.reduce((a, b) => (SEV_ORDER[b] > SEV_ORDER[a] ? b : a));
}

export function deriveIncidences(sectors) {
  const list = Array.isArray(sectors) ? sectors : [];
  const out = [];
  for (const sec of list) {
    for (const item of sec?.items || []) {
      for (const [asc, cell] of Object.entries(item?.cells || {})) {
        if (cell?.estado === 'FALLA') {
          out.push({
            asc,
            sector: sec.sector,
            det: cell.detalle || '',
            severidad: maxSeveridad(cell.hallazgos),
            urgente: /urgente/i.test(cell.detalle || ''),
          });
        }
      }
    }
  }
  return out;
}
